// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_skip__PZ8pa {
  position: fixed;
  top: 0.5rem;
  left: 0.5rem;
  z-index: 20000;
  padding: 0.75rem 1.25rem;
  background: var(--kur-gold);
  color: #111;
  font-weight: 700;
  border-radius: 6px;
  text-decoration: none;
}
.layout_skip__PZ8pa:not(:focus) {
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/LAYOUT/layout.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".skip {\n  position: fixed;\n  top: 0.5rem;\n  left: 0.5rem;\n  z-index: 20000;\n  padding: 0.75rem 1.25rem;\n  background: var(--kur-gold);\n  color: #111;\n  font-weight: 700;\n  border-radius: 6px;\n  text-decoration: none;\n}\n.skip:not(:focus) {\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skip": `layout_skip__PZ8pa`
};
export default ___CSS_LOADER_EXPORT___;
